import { Role } from "@/router/_helper";

const summary = {
  path: "/staff-summary",
  name: "staffSummary",
  component: () => import(/* webpackChunkName: "staffSummary" */ "@/components/staff/StaffSummary.vue"),
  meta: { authorize: [Role.Admin, Role.ComplianceStaff], requiresAuth: true }
};

export default summary;
